<div class="support-chat-desktop-wrapper">
  <nz-tabset (nzSelectedIndexChange)="tabChanged($event)">
    <!--  FOREIGNERS  -->

    <nz-tab [nzTitle]="foreignersTabTitle">
      <div class="chat-filters-wrapper">
        <div class="chat-filters" *ngIf="isChatFiltersVisible" [@supportChatFilters]>
          <ng-template #indicatorTemplate>
            <span nz-icon nzType="loading"></span>
          </ng-template>
          <nz-spin
            [nzIndicator]="indicatorTemplate"
            [nzDelay]="50"
            [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
            [nzSize]="'large'">
            <ul nz-menu>
              <li nz-menu-item>
                <div class="filter-item" style="display: flex; justify-content: space-between; align-items: center">
                  <nz-input-group [nzSuffix]="suffixIconSearch" class="query-input foreigners">
                    <input
                      type="text"
                      nz-input
                      nzSize="small"
                      appSetTabIndex
                      [ngModel]="(pagination$ | async)?.supportedUserName || ''"
                      (ngModelChange)="debouncedSearch({ supportedUserName: $event })"
                      placeholder="{{ 'CHAT.SEARCH_BY_NAME' | translate }}" />
                  </nz-input-group>
                  <ng-template #suffixIconSearch>
                    <span nz-icon nzType="search" *ngIf="!(pagination$ | async)?.supportedUserName"> </span>
                    <span
                      nz-icon
                      class="ant-input-clear-icon"
                      nzTheme="fill"
                      nzType="close-circle"
                      *ngIf="(pagination$ | async)?.supportedUserName"
                      (click)="searchSupportChats({ supportedUserName: null })"></span>
                  </ng-template>
                  <nz-switch
                    [ngModel]="(pagination$ | async)?.onlyAssignedToMe"
                    (ngModelChange)="searchSupportChats({ onlyAssignedToMe: $event })"
                    [nzUnCheckedChildren]="AllIcon"
                    [nzCheckedChildren]="OnlyMineIcon"
                    nz-tooltip
                    [nzTooltipTitle]="(pagination$ | async)?.onlyAssignedToMe ? OnlyMineTooltip : AllTooltip">
                  </nz-switch>
                  <ng-template #OnlyMineIcon>
                    <span nz-icon nzType="user-switch"></span>
                  </ng-template>
                  <ng-template #AllIcon>
                    <span nz-icon nzType="global"></span>
                  </ng-template>
                  <ng-template #OnlyMineTooltip>
                    <span [innerHTML]="'CHAT.ONLY_ASSIGNED_TO_ME' | translate"></span>
                  </ng-template>
                  <ng-template #AllTooltip>
                    <span [innerHTML]="'CHAT.ALL_ASSIGNED' | translate"></span>
                  </ng-template>
                </div>
              </li>
            </ul>
          </nz-spin>
        </div>
      </div>

      <div class="chat-list-wrapper">
        <ng-template #indicatorTemplate>
          <span nz-icon nzType="loading"></span>
        </ng-template>
        <nz-spin
          [nzIndicator]="indicatorTemplate"
          [nzDelay]="10"
          [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
          class="main-support-chats-list-loading-indicator">
          <div class="list" #chatsList>
            <div
              *ngFor="let supportChat of foreignersSupportChatsList$ | async"
              class="item"
              (click)="openSupportChat(supportChat)"
              [class.open]="supportChat.id === (openSupportChat$ | async)?.supportChat?.id"
              [class.unread]="supportChat.hasUnreadMessages"
              [class.attention-required]="supportChat.marker === SupportChatMarker.ATTENTION_REQUIRED"
              [class.already-handled]="supportChat.marker === SupportChatMarker.ALREADY_HANDLED"
              [class.comeback-later]="supportChat.marker === SupportChatMarker.COMEBACK_LATER">
              <div class="column">
                <div class="last-message">
                  <span *ngIf="supportChat.lastMessageAt; else noAvatar" class="avatar-like">
                    {{ supportChat.lastMessageAt | date: 'dd.MM' }}

                    <span
                      class="presence-dot"
                      [class.online]="supportChat.supportedUserOnline"
                      [class.offline]="!supportChat.supportedUserOnline">
                    </span>
                  </span>

                  <ng-template #noAvatar>
                    <span
                      class="presence-dot standalone"
                      [class.online]="supportChat.supportedUserOnline"
                      [class.offline]="!supportChat.supportedUserOnline">
                    </span>
                  </ng-template>
                </div>

                <div class="name">
                  {{ supportChat.supportedUser?.name || 'MISSING USERNAME' }}
                </div>
              </div>
              <div class="column">
                <ng-container [ngSwitch]="supportChat.marker">
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.ATTENTION_REQUIRED"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    priority_high
                  </mat-icon>
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.COMEBACK_LATER"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    schedule
                  </mat-icon>
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.ALREADY_HANDLED"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    check_circle
                  </mat-icon>
                </ng-container>

                <div class="action-buttons-wrapper" style="position: relative">
                  <div class="tooltip-wrapper" *ngIf="hasPermission('CAN_EDIT_FOREIGNER')">
                    <button
                      *appRequiredSupportingCompany="{
                        requiredAccessLevel: SupportingCompanyAccessLevel.canEditProcesses,
                        companyId: supportChat.supportedUser.companyId
                      }"
                      nz-button
                      nzType="text"
                      nzShape="round"
                      nzSize="small"
                      class="application-list-trigger"
                      (click)="closeMenus($event)"
                      [routerLink]="['/management/foreigner-details', supportChat.supportedUserId]"
                      [queryParams]="{ tabIndex: 1 }">
                      <mat-icon fontSet="material-icons-outlined">collections_bookmark</mat-icon>
                    </button>
                    <span class="tooltip-text">{{
                      'COMMON.REDIRECT.GO_TO_FOREIGNER_APPLICATIONS_LIST' | translate
                    }}</span>
                  </div>

                  <button
                    nz-button
                    nzType="text"
                    nzShape="round"
                    nzSize="small"
                    class="markers-dropdown-trigger"
                    (click)="toggleMenu($event, supportChat.id, ROLES_KEYS.Foreigner)">
                    <mat-icon fontSet="material-icons-outlined">more_horiz</mat-icon>
                  </button>

                  <div
                    *ngIf="isMenuVisible && activeMenuId === supportChat.id"
                    class="custom-markers-menu"
                    [class.up]="menuDirection === 'up'"
                    [class.down]="menuDirection === 'down'"
                    [style.position]="'fixed'"
                    [style.top.px]="menuTop"
                    [style.height.px]="menuHeight"
                    (click)="$event.stopPropagation()">
                    <ng-container *ngFor="let item of availableMenuItems">
                      <ng-container *ngIf="!item.supportedTypes || item.supportedTypes.includes(ROLES_KEYS.Foreigner)">
                        <div
                          class="menu-item"
                          [class.disabled]="item.disabledFn && item.disabledFn(supportChat)"
                          *appRequiredSupportingCompany="
                            item.requiredSupportingCompanyAccessLevel
                              ? {
                                  requiredAccessLevel: item.requiredSupportingCompanyAccessLevel,
                                  companyId: supportChat.supportedUser.companyId
                                }
                              : null
                          "
                          [routerLink]="item.routerLink ? item.routerLink.concat(supportChat.supportedUserId) : null"
                          [queryParams]="item.queryParams ? item.queryParams : null"
                          (click)="actionHandlers[item.actionKey](supportChat); closeMenus($event)">
                          <mat-icon
                            class="marker-icon"
                            [ngClass]="item.iconCustomClass ? item.iconCustomClass : 'icon-grey'"
                            fontSet="material-icons-outlined"
                            >{{ item.icon }}
                          </mat-icon>
                          {{ item.labelKey | translate }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="item last-item">
              <div *ngIf="loadingMoreChats$ | async" class="loading-wrapper" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
              </div>

              <div class="no-more-items-message" *ngIf="allChatsLoaded">
                {{ 'CHAT.NO_MORE_SUPPORT_CHATS' | translate }}
              </div>
            </div>
          </div>
        </nz-spin>
      </div>
    </nz-tab>

    <!--  MANAGERS / EMPLOYER  -->

    <nz-tab [nzTitle]="employersTabTitle">
      <div class="chat-filters-wrapper">
        <div class="chat-filters" *ngIf="isChatFiltersVisible" [@supportChatFilters]>
          <ng-template #indicatorTemplate>
            <span nz-icon nzType="loading"></span>
          </ng-template>
          <nz-spin
            [nzIndicator]="indicatorTemplate"
            [nzDelay]="50"
            [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
            [nzSize]="'large'">
            <ul nz-menu>
              <li nz-menu-item>
                <div class="filter-item" style="display: flex; justify-content: space-between; align-items: center">
                  <nz-input-group [nzSuffix]="suffixIconSearch" class="query-input employers">
                    <input
                      type="text"
                      nz-input
                      nzSize="small"
                      appSetTabIndex
                      [ngModel]="(pagination$ | async)?.supportedUserName || ''"
                      (ngModelChange)="debouncedSearch({ supportedUserName: $event })"
                      placeholder="{{ 'CHAT.SEARCH_BY_NAME' | translate }}" />
                  </nz-input-group>
                  <ng-template #suffixIconSearch>
                    <span nz-icon nzType="search" *ngIf="!(pagination$ | async)?.supportedUserName"> </span>
                    <span
                      nz-icon
                      class="ant-input-clear-icon"
                      nzTheme="fill"
                      nzType="close-circle"
                      *ngIf="(pagination$ | async)?.supportedUserName"
                      (click)="searchSupportChats({ supportedUserName: null })"></span>
                  </ng-template>
                </div>
              </li>
            </ul>
          </nz-spin>
        </div>
      </div>

      <div class="chat-list-wrapper">
        <ng-template #indicatorTemplate>
          <span nz-icon nzType="loading"></span>
        </ng-template>
        <nz-spin
          [nzIndicator]="indicatorTemplate"
          [nzDelay]="10"
          [nzSpinning]="(loadingChatsList$ | async) || (loadingTranscriptionChat$ | async)"
          class="main-support-chats-list-loading-indicator">
          <div class="list" #chatsList>
            <div
              *ngFor="let supportChat of employersSupportChatsList$ | async"
              class="item"
              (click)="openSupportChat(supportChat)"
              [class.open]="supportChat.id === (openSupportChat$ | async)?.supportChat?.id"
              [class.unread]="supportChat.hasUnreadMessages"
              [class.attention-required]="supportChat.marker === SupportChatMarker.ATTENTION_REQUIRED"
              [class.already-handled]="supportChat.marker === SupportChatMarker.ALREADY_HANDLED"
              [class.comeback-later]="supportChat.marker === SupportChatMarker.COMEBACK_LATER">
              <div class="column">
                <div class="last-message">
                  <span *ngIf="supportChat.lastMessageAt; else noAvatar" class="avatar-like">
                    {{ supportChat.lastMessageAt | date: 'dd.MM' }}

                    <span
                      class="presence-dot"
                      [class.online]="supportChat.supportedUserOnline"
                      [class.offline]="!supportChat.supportedUserOnline">
                    </span>
                  </span>

                  <ng-template #noAvatar>
                    <span
                      class="presence-dot standalone"
                      [class.online]="supportChat.supportedUserOnline"
                      [class.offline]="!supportChat.supportedUserOnline">
                    </span>
                  </ng-template>
                </div>

                <div class="name">
                  {{ supportChat.supportedUser?.name || 'MISSING USERNAME' }}
                </div>
              </div>
              <div class="column">
                <ng-container [ngSwitch]="supportChat.marker">
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.ATTENTION_REQUIRED"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    priority_high
                  </mat-icon>
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.COMEBACK_LATER"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    schedule
                  </mat-icon>
                  <mat-icon
                    *ngSwitchCase="SupportChatMarker.ALREADY_HANDLED"
                    class="marker-icon"
                    fontSet="material-icons-outlined">
                    check_circle
                  </mat-icon>
                </ng-container>

                <div class="action-buttons-wrapper" style="position: relative">
                  <button
                    nz-button
                    nzType="text"
                    nzShape="round"
                    nzSize="small"
                    class="markers-dropdown-trigger"
                    (click)="toggleMenu($event, supportChat.id, ROLES_KEYS.Employer)">
                    <mat-icon fontSet="material-icons-outlined">more_horiz</mat-icon>
                  </button>

                  <div
                    *ngIf="isMenuVisible && activeMenuId === supportChat.id"
                    class="custom-markers-menu"
                    [class.up]="menuDirection === 'up'"
                    [class.down]="menuDirection === 'down'"
                    [style.position]="'fixed'"
                    [style.top.px]="menuTop"
                    [style.height.px]="menuHeight"
                    (click)="$event.stopPropagation()">
                    <ng-container *ngFor="let item of availableMenuItems">
                      <ng-container *ngIf="!item.supportedTypes || item.supportedTypes.includes(ROLES_KEYS.Employer)">
                        <div
                          class="menu-item"
                          [class.disabled]="item.disabledFn && item.disabledFn(supportChat)"
                          *appRequiredSupportingCompany="
                            item.requiredSupportingCompanyAccessLevel
                              ? {
                                  requiredAccessLevel: item.requiredSupportingCompanyAccessLevel,
                                  companyId: supportChat.supportedUser.companyId
                                }
                              : null
                          "
                          [routerLink]="item.routerLink ? item.routerLink.concat(supportChat.supportedUserId) : null"
                          [queryParams]="item.queryParams ? item.queryParams : null"
                          (click)="actionHandlers[item.actionKey](supportChat); closeMenus($event)">
                          <mat-icon
                            class="marker-icon"
                            [ngClass]="item.iconCustomClass ? item.iconCustomClass : 'icon-grey'"
                            fontSet="material-icons-outlined"
                            >{{ item.icon }}
                          </mat-icon>
                          {{ item.labelKey | translate }}
                        </div>
                      </ng-container>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>
            <div class="item last-item">
              <div *ngIf="loadingMoreChats$ | async" class="loading-wrapper" role="status" aria-live="polite">
                <span class="sr-only">
                  {{ 'COMMON.LAYOUT.LOADING' | translate }}
                </span>

                <mat-spinner [diameter]="35" [attr.aria-hidden]="true"> </mat-spinner>
              </div>

              <div class="no-more-items-message" *ngIf="allChatsLoaded">
                {{ 'CHAT.NO_MORE_SUPPORT_CHATS' | translate }}
              </div>
            </div>
          </div>
        </nz-spin>
      </div>
    </nz-tab>
  </nz-tabset>

  <ng-template #foreignersTabTitle>
    <span>
      {{ 'COMMON.LABEL.FOREIGNERS' | translate }}
      <nz-badge [nzCount]="myUnreadCountForeigners$ | async" [nzOverflowCount]="99" class="tab-badge"> </nz-badge>
    </span>
  </ng-template>

  <ng-template #employersTabTitle>
    <span>
      {{ 'COMMON.LABEL.EMPLOYERS' | translate }}
      <nz-badge [nzCount]="myUnreadCountEmployers$ | async" [nzOverflowCount]="99" class="tab-badge"> </nz-badge>
    </span>
  </ng-template>
</div>
